var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoneyIcon = function SvgMoneyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.005 2.948a.5.5 0 0 1 .5.5L12.5 5.986h3.065a.5.5 0 1 1 0 1h-5.529c-.9 0-2.037.667-2.037 2.043 0 1.37 1.13 2.033 2.043 2.056h2.106c1.208 0 2.408.112 3.315.607a2.8 2.8 0 0 1 1.13 1.104q.406.73.406 1.772c0 1.416-.565 2.33-1.46 2.855-.844.495-1.918.603-2.882.603h-.153v2.46a.5.5 0 1 1-1 0v-2.46H7.5a.5.5 0 1 1 0-1h5.158c.926 0 1.773-.112 2.377-.465.553-.325.965-.89.965-1.993 0-.566-.11-.98-.28-1.287a1.8 1.8 0 0 0-.736-.71c-.668-.366-1.644-.486-2.835-.486h-2.122C8.755 12.057 7 11.115 7 9.03c0-2.082 1.752-3.043 3.037-3.043h1.464l.004-2.54a.5.5 0 0 1 .5-.498",
    clipRule: "evenodd"
  })));
};
export default SvgMoneyIcon;